
import ClickOutside from 'vue-click-outside'
import { computed, defineComponent, PropType, ref } from 'vue'
import { SelectColorsArray, SelectColorsEnum, SelectColorsMap } from '../../components/Select/BSelect.types'

export default defineComponent({
  name: 'BSelect',
  props: {
    data: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Object, Number],
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
    field: {
      type: String,
      required: true,
    },
    color: {
      type: String as PropType<SelectColorsEnum>,
      default: SelectColorsEnum.SUCCESS,
      validator: (prop: SelectColorsEnum) => SelectColorsArray.includes(prop),
    },
  },
  directives: {
    ClickOutside
  },
  setup(props, { emit }) {
    const isOpen = ref(props.open)
    const updatedValue = ref<any>(props.value)

    const colorClasses = computed(() => SelectColorsMap[props.color])

    const isSelected = (el: any) => computed(() => updatedValue.value === el)

    function closeDropdown() {
      isOpen.value = false
      emit('close', false)
    }

    function openDropdown() {
      isOpen.value = true
      emit('open', true)

    }

    function select(newValue: any) {
      updatedValue.value = newValue
      emit('valueSelect', newValue)
      closeDropdown()
    }

    return {
      closeDropdown,
      colorClasses,
      isOpen,
      isSelected,
      openDropdown,
      select,
      updatedValue,
    }
  },
})
